import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=c81b7a0a&scoped=true&"
import script from "./CategoryButton.vue?vue&type=script&lang=js&"
export * from "./CategoryButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryButton.vue?vue&type=style&index=0&id=c81b7a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81b7a0a",
  null
  
)

export default component.exports